import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FaWhatsapp } from 'react-icons/fa';
import { useHistory, useParams } from 'react-router-dom';
import { Loading } from '@/components/loaders';
import { useWhatsappChannelConnector } from '@/features/connectors/whatsapp';
import { WhatsappBusinessOnboardingBlock } from '@/features/campaigns/v2/components/WhatsappBusinessOnboardingBlock';
import RouteConstants from '@/features/router/RouteConstants';
import { PageLayout } from '@/global/components';
import { Button } from '@/lib';
import { WhatsappInboxPanes } from './WhatsappInboxPanes';

export const WhatsappInboxContainer: FC = () => {
  const { t } = useTranslation('whatsappInbox');
  const history = useHistory();
  const { conversationId } = useParams<{ conversationId?: string }>();
  const { isLoading, businessInstanceId, needsOnboarding, onboarding } = useWhatsappChannelConnector();
  const ready = !isLoading && !!businessInstanceId && !needsOnboarding;

  return (
    <PageLayout className='min-h-0'>
      <header className='flex shrink-0 items-center gap-3'>
        <span className='flex size-10 items-center justify-center rounded-full bg-primary-background'>
          <FaWhatsapp className='size-5 text-brand-600' />
        </span>
        <div>
          <h1 className='text-xl font-semibold text-primary-900'>{t('title')}</h1>
          <p className='text-sm text-primary-900/60'>{t('subtitle')}</p>
        </div>
      </header>

      {isLoading ? <Loading /> : null}
      {!isLoading && !businessInstanceId ? (
        <div className='space-y-3 rounded-xl border border-primary-border bg-white-100 p-6'>
          <p className='text-primary-900'>{t('notConnected')}</p>
          <Button intent='secondary' onClick={() => history.push(RouteConstants.destinations)}>
            {t('goToDestinations')}
          </Button>
        </div>
      ) : null}
      {!isLoading && businessInstanceId && needsOnboarding ? <WhatsappBusinessOnboardingBlock onboardingUrl={onboarding?.onboardingUrl} /> : null}

      {ready ? (
        <div className='flex min-h-0 flex-1 flex-col'>
          <WhatsappInboxPanes
            selectedId={conversationId}
            onSelect={(id) => history.push(`${RouteConstants.whatsappInbox}/${id}`)}
            onBack={() => history.push(RouteConstants.whatsappInbox)}
          />
        </div>
      ) : null}
    </PageLayout>
  );
};
